import React from 'react';
import { Link } from 'react-router-dom';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const { FiArrowLeft } = FiIcons;

const PageHeader = ({ title, subtitle, backLink, backText = 'Back', actions = [], stats = [] }) => {
  return (
    <div className="bg-white border-b border-gray-200 px-4 sm:px-6 lg:px-8 py-6">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center space-x-4">
            {backLink && (
              <Link
                to={backLink}
                className="text-gray-600 hover:text-gray-900 transition-colors"
                title={backText}
              >
                <SafeIcon icon={FiArrowLeft} className="text-2xl" />
              </Link>
            )}
            <div>
              <h1 className="text-2xl sm:text-3xl font-bold text-gray-900">{title}</h1>
              {subtitle && (
                <p className="text-gray-600 mt-1">{subtitle}</p>
              )}
            </div>
          </div>

          {/* Actions */}
          {actions.length > 0 && (
            <div className="flex items-center space-x-3">
              {actions.map((action, index) => (
                <div key={index}>
                  {action.type === 'link' ? (
                    <Link
                      to={action.path}
                      state={action.state}
                      className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm transition-colors ${action.variant === 'primary'
                          ? 'text-white bg-blue-600 hover:bg-blue-700'
                          : action.variant === 'secondary'
                            ? 'text-blue-700 bg-blue-100 hover:bg-blue-200'
                            : 'text-gray-700 bg-white border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                      {action.icon && <SafeIcon icon={action.icon} className="mr-2" />}
                      {action.label}
                    </Link>
                  ) : (
                    <button
                      onClick={action.onClick}
                      className={`inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm transition-colors ${action.variant === 'primary'
                          ? 'text-white bg-blue-600 hover:bg-blue-700'
                          : action.variant === 'secondary'
                            ? 'text-blue-700 bg-blue-100 hover:bg-blue-200'
                            : 'text-gray-700 bg-white border-gray-300 hover:bg-gray-50'
                        }`}
                    >
                      {action.icon && <SafeIcon icon={action.icon} className="mr-2" />}
                      {action.label}
                    </button>
                  )}
                </div>
              ))}
            </div>
          )}
        </div>

        {/* Stats */}
        {stats.length > 0 && (
          <div className="mt-6 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4">
            {stats.map((stat, index) => (
              <div key={index} className="bg-gray-50 rounded-lg p-4">
                <div className="flex items-center justify-between">
                  <div>
                    <p className="text-sm font-medium text-gray-600">{stat.label}</p>
                    <p className={`text-2xl font-bold ${stat.color || 'text-gray-900'}`}>
                      {stat.value}
                    </p>
                  </div>
                  {stat.icon && (
                    <SafeIcon icon={stat.icon} className={`text-3xl ${stat.iconColor || 'text-gray-400'}`} />
                  )}
                </div>
                {stat.description && (
                  <p className="text-xs text-gray-500 mt-1">{stat.description}</p>
                )}
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default PageHeader;